import { render } from "./DrawerHost.vue?vue&type=template&id=2955295f&scoped=true&ts=true"
import script from "./DrawerHost.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerHost.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerHost.vue?vue&type=style&index=0&id=2955295f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2955295f"],['__file',"src/lib/components/DrawerHost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2955295f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2955295f', __exports__)) {
    api.reload('2955295f', __exports__)
  }
  
  module.hot.accept("./DrawerHost.vue?vue&type=template&id=2955295f&scoped=true&ts=true", () => {
    api.rerender('2955295f', render)
  })

}


export default __exports__